import { blacklistEmailDomains } from 'shared/constants/blacklist-email-domains'

export const isBlacklistEmailDomain = (email: string) =>
  blacklistEmailDomains.includes(email.split('@')[1])
